module.exports = __webpack_public_path__ + "static/media/es.956a30fd.svg";